<template>
  <div class="accountSetting crypto_addresses pl-xl-4">
    <div class="pb-3 mb-4">
      <h3 class="medium mb-4">Crypto Addresses</h3>
      <p>
        This is a list of cryptocurrency addresses associated with your Capital
        Wallet account. These addresses do not expire. You can use them to
        receive crypto as long as your Capital Wallet account is active.
      </p>
      <p>
        <strong>Important Note</strong>: Crypto addresses are asset specific. Do
        not send Bitcoin to a Bitcoin Cash address, for example, otherwise your
        funds will be lost
      </p>
      <div class="border-top py-4 my-4">
        <div class="selectmenu position-relative d-inline-flex">
          <a
            @click.prevent="currencies = !currencies"
            href="javascript:void(0)"
            class="btn d-inline-flex align-items-center"
            ><span class="mx-2">All Currencies</span
            ><feather type="chevron-down" class="ml-2"></feather
          ></a>
          <ul
            class="dropdown_menu dropdown_menu--animated dropdown_menu-6"
            :class="currencies ? 'show' : ''"
          >
            <li><a href="javascript:void(0)">All Assets</a></li>
            <li><a href="javascript:void(0)"> All Assets</a></li>
          </ul>
        </div>
      </div>
      <div class="border position-relative border-radius-15 mt-4">
        <div class="marketData table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Asset</th>
                <th>Address</th>
                <th>Created</th>
              </tr>
            </thead>
            <tbody v-if="cryptoAddresses.records.length">
              <tr v-for="address in cryptoAddresses.records">
                <td>
                  <span class="d-flex align-items-center">
                    <span class="inTableIcon ml-0"
                      ><img
                        :src="
                          '../../../../../static/website/images/crypto_logos/' +
                          address.currency.toLowerCase() +
                          '.png'
                        "
                        alt="Crypto name"
                    /></span>
                    <p class="mb-0 themecolor medium">
                      {{ getCurrencyName(address.currency) }}
                    </p>
                  </span>
                </td>
                <td>
                  <span class="d-flex align-items-center"
                    >{{ address.address }}
                    <a
                      v-clipboard:copy="address.address"
                      v-clipboard:success="() => onCopy()"
                      class="ml-2"
                      href="javascript:void(0)"
                    >
                      <div class="copied" v-if="msgCopied">
                        <span>Copied</span>
                      </div>
                      <feather type="copy"></feather></a
                  ></span>
                </td>
                <td>{{ getDate(address.created) }}</td>
              </tr>
              <!-- <tr>
                <td>
                  <span class="d-flex align-items-center">
                    <span class="inTableIcon ml-0"
                      ><img
                        src="../../../../../static/website/images/crypto_logos/btc.png"
                        alt="Crypto name"
                    /></span>
                    <p class="mb-0 themecolor medium">Bitcoin</p>
                  </span>
                </td>
                <td>
                  <span class="d-flex align-items-center"
                    >3HdfnVrjvWkektKKJmXjbzkHsEavnnTST2
                    <a class="ml-2" href="javascript:void(0)">
                      <feather type="copy"></feather></a
                  ></span>
                </td>
                <td>5 days ago</td>
                <td>
                  <a href="javascript:void(0)" class="status border">Details</a>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="d-flex align-items-center">
                    <span class="inTableIcon ml-0"
                      ><img
                        src="../../../../../static/website/images/crypto_logos/btc.png"
                        alt="Crypto name"
                    /></span>
                    <p class="mb-0 themecolor medium">Bitcoin</p>
                  </span>
                </td>
                <td>
                  <span class="d-flex align-items-center"
                    >3HdfnVrjvWkektKKJmXjbzkHsEavnnTST2
                    <a class="ml-2" href="javascript:void(0)">
                      <feather type="copy"></feather></a
                  ></span>
                </td>
                <td>5 days ago</td>
                <td>
                  <a href="javascript:void(0)" class="status border">Details</a>
                </td>
              </tr>
              <tr>
                <td>
                  <span class="d-flex align-items-center">
                    <span class="inTableIcon ml-0"
                      ><img
                        src="../../../../../static/website/images/crypto_logos/btc.png"
                        alt="Crypto name"
                    /></span>
                    <p class="mb-0 themecolor medium">Bitcoin</p>
                  </span>
                </td>
                <td>
                  <span class="d-flex align-items-center"
                    >3HdfnVrjvWkektKKJmXjbzkHsEavnnTST2
                    <a class="ml-2" href="javascript:void(0)">
                      <feather type="copy"></feather></a
                  ></span>
                </td>
                <td>5 days ago</td>
                <td>
                  <a href="javascript:void(0)" class="status border">Details</a>
                </td>
              </tr> -->
            </tbody>
            <tbody v-else>
              <tr>
                <td class="text-center" colspan="3">No addresses found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { registerStepsMixins } from "@/plugins/registerSteps";
import moment from "moment";

export default {
  name: "accountprofile",
  mixins: [registerStepsMixins],
  data() {
    return {
      submitted: false,
      currencies: false,
      msgCopied: false,
    };
  },
  components: {},
  created() {
    this._runGetCryptoAddresses({
      globalParams: {},
      localParams: {
        parameter: this,
      },
    });
  },
  methods: {
    getDate(date) {
      return moment(date).format("Do MMM, YYYY");
    },
    getCurrencyName(symbol) {
      let currencyName = "";
      for (let key in this.$env_var.walletCurrencyList) {
        if (this.$env_var.walletCurrencyList[key].symbol == symbol) {
          currencyName = this.$env_var.walletCurrencyList[key].currency_name;
          break;
        }
      }
      return currencyName;
    },
    onCopy() {
      this.msgCopied = true;
      setTimeout(() => {
        this.msgCopied = false;
      }, 3000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/settings/files/crypto_addresses.vue